var n,o;!function(n){n.H1="h1",n.H2="h2",n.H3="h3"}(n||(n={})),function(n){n.BOLD="bold",n.NORMAL="normal",n.LIGHT="light"}(o||(o={}));export{n as HeadingType,o as HeadingWeight};
//# sourceMappingURL=HeadingConstants.js.map
